export const DEFAULT_COMPONENT_MESSAGE =
  '{Здравствуйте|Добрый день|Доброго времени суток|Приветствуем|Приветствуем Вас|Привет} {Благодарю|Благодарим} {за подписку|что подписались}';
